import * as dataStore from './DataStore';
import { performJsonpGetRequest } from "../lib/HttpRequest";
import * as utility from "../utility";

const bookListsDataRetrieved = "bookListsDataRetrievedCallback";
function generateLink(ui){
    let profileData = dataStore.getProfileData();

    return utility.getNovSchema() + 
    dataStore.getBaseUrl() +
    "/Display/TreeNodeContentJson?" +
    "profile=" + profileData.Profile +
    "&password=" + profileData.Password +
    "&ui=" + ui +
    "&custLinks=" + dataStore.getCustLinks();
}

function getRequest(url, postAction) {
  let callback = data => {
      postAction(data);
  };

  utility.attachFunctionToCallback(callback, bookListsDataRetrieved);

  performJsonpGetRequest(url, bookListsDataRetrieved);

}

export function getBookLists(ui, postAction) {
    let link = generateLink(ui);
    getRequest(link,postAction);   
}



// WEBPACK FOOTER //
// ./src/data/BookListsSelector.js